<tariff-check-header></tariff-check-header>
<mat-toolbar class="flex-row second-toolbar">
  <button mat-icon-button (click)="back()" data-cy="back">
    <mat-icon fontSet="fas" fontIcon="fa-arrow-left"></mat-icon>
  </button>
  <div class="toolbar-title center" data-cy="title">Bewertung exportieren</div>
</mat-toolbar>
<main>
  @if (model) {
  <div class="flex-row flex-col-md gap-32">
    <div class="flex-grow-50 md">
      <form novalidate>
        <mat-card>
          <mat-card-header>
            <mat-card-title>Bewertung individualisieren</mat-card-title>
            <mat-card-subtitle> Meine Daten </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="flex-row flex-col-sm justify-between gap-16 gap-0-sm">
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Vorname</mat-label>
                <input
                  type="text"
                  aria-label="firstname"
                  matInput
                  [(ngModel)]="model.firstName"
                  name="firstname"
                  data-cy="firstname"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Nachname</mat-label>
                <input
                  type="text"
                  aria-label="lastname"
                  matInput
                  [(ngModel)]="model.lastName"
                  name="lastname"
                  data-cy="lastname"
                />
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-sm justify-between gap-16 gap-0-sm">
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Firma</mat-label>
                <input
                  type="text"
                  aria-label="companyName"
                  matInput
                  [(ngModel)]="model.companyName"
                  name="companyName"
                  data-cy="field-companyName"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Strasse</mat-label>
                <input
                  type="text"
                  aria-label="street"
                  matInput
                  [(ngModel)]="model.street"
                  name="street"
                  data-cy="street"
                />
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-sm justify-between gap-16 gap-0-sm">
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>PLZ</mat-label>
                <input
                  type="text"
                  aria-label="zip"
                  matInput
                  [(ngModel)]="model.zip"
                  name="zip"
                  data-cy="zip"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Stadt</mat-label>
                <input
                  type="text"
                  aria-label="city"
                  matInput
                  [(ngModel)]="model.city"
                  name="city"
                  data-cy="city"
                />
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-sm justify-between gap-16 gap-0-sm">
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Telefon</mat-label>
                <input
                  type="text"
                  aria-label="phone"
                  matInput
                  [(ngModel)]="model.phone"
                  name="phone"
                  data-cy="phone"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="form-grow">
                <mat-label>E-Mail</mat-label>
                <input
                  type="text"
                  aria-label="email"
                  matInput
                  [(ngModel)]="model.emailConsultant"
                  name="email"
                  data-cy="email"
                />
              </mat-form-field>
            </div>
          </mat-card-content>
          <mat-card-header>
            <mat-card-subtitle>Analyse für</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="flex-row flex-col-sm justify-between gap-16 gap-0-sm">
              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Anrede</mat-label>
                <mat-select
                  type="text"
                  aria-label="Anrede"
                  data-cy="gender"
                  [(ngModel)]="model.gender"
                  name="gender"
                >
                  <mat-option value="m">Herr</mat-option>
                  <mat-option value="f">Frau</mat-option>
                  <mat-option value="d">Neutral</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="flex-grow">
                <mat-label>Vorname / Nachname</mat-label>
                <input
                  type="text"
                  aria-label="name"
                  matInput
                  [(ngModel)]="model.name"
                  name="name"
                  data-cy="name"
                />
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                placeholder="Notiz / Bemerkung"
                type="text"
                aria-label="notice"
                matInput
                [(ngModel)]="model.note"
                name="note"
                data-cy="note"
              ></textarea>
            </mat-form-field>
          </mat-card-content>
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <div class="flex-row justify-between flex-col-xs gap-16 gap-0-xs">
              <div class="flex-grow">
                @if (currentTariff) {

                <mat-card-subtitle>aktueller Tarif</mat-card-subtitle>
                <div
                  class="flex-row flex-col-sm flex-col-lg-md justify-between gap-16 gap-0-lg-md gap-0-sm"
                >
                  <mat-form-field
                    appearance="outline"
                    class="flex-grow-30 sm lg"
                  >
                    <mat-label>Betrag</mat-label>
                    <input
                      type="text"
                      aria-label="Betrag"
                      matInput
                      [(ngModel)]="model.currentTariffPrice"
                      name="currentTariffPrice"
                      data-cy="current-tariff-price"
                    />
                    <mat-icon matSuffix>euro</mat-icon>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="flex-grow-70 sm lg"
                  >
                    <mat-label>Zahlweise</mat-label>
                    <mat-select
                      type="text"
                      aria-label="Zahlweise"
                      [(ngModel)]="model.currentTariffPayment"
                      name="currentTariffPayment"
                      data-cy="current-tariff-payment"
                    >
                      <mat-option value="jährlich">jährlich</mat-option>
                      <mat-option value="halbjährlich">halbjährlich</mat-option>
                      <mat-option value="vierteljährlich"
                        >vierteljährlich</mat-option
                      >
                      <mat-option value="monatlich">monatlich</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                }
              </div>
              <div class="flex-grow">
                @if (offerTariff) {
                <mat-card-subtitle>Optimierung</mat-card-subtitle>
                <div
                  class="flex-row flex-col-sm flex-col-lg-md justify-between gap-16 gap-0-lg-md gap-0-sm"
                >
                  <mat-form-field
                    appearance="outline"
                    class="flex-grow-30 sm lg"
                  >
                    <mat-label>Betrag</mat-label>
                    <input
                      type="text"
                      aria-label="Betrag"
                      matInput
                      [(ngModel)]="model.offerTariffPrice"
                      name="offerTariffPrice"
                      data-cy="offer-tariff-price"
                    />
                    <mat-icon matSuffix>euro</mat-icon>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="flex-grow-70 sm lg"
                  >
                    <mat-label>Zahlweise</mat-label>
                    <mat-select
                      type="text"
                      aria-label="Zahlweise"
                      [(ngModel)]="model.offerTariffPayment"
                      name="offerTariffPayment"
                      data-cy="offer-tariff-payment"
                    >
                      <mat-option value="jährlich">jährlich</mat-option>
                      <mat-option value="halbjährlich">halbjährlich</mat-option>
                      <mat-option value="vierteljährlich"
                        >vierteljährlich</mat-option
                      >
                      <mat-option value="monatlich">monatlich</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                }
              </div>
            </div>
          </mat-card-content>

          <mat-card-header>
            <mat-card-subtitle>Ansicht</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="flex-row flex-col-sm justify-between">
              <p>
                <mat-slide-toggle
                  [(ngModel)]="model.enableForeword"
                  name="enableForeword"
                  data-cy="enableForeword"
                  >mit Vorwort</mat-slide-toggle
                >
              </p>
              <p>
                <mat-slide-toggle
                  [(ngModel)]="model.enableDonut"
                  name="enableDonut"
                  data-cy="enableDonut"
                  >mit Donut</mat-slide-toggle
                >
              </p>
              <p>
                <mat-slide-toggle
                  [(ngModel)]="model.enableCriteria"
                  name="enableCriteria"
                  data-cy="enableCriteria"
                  >mit Kriterien</mat-slide-toggle
                >
              </p>
              <p>
                <mat-slide-toggle
                  [(ngModel)]="model.enableExtraCriteria"
                  name="enableExtraCriteria"
                  [checked]="model.enableCriteria"
                  [disabled]="!model.enableCriteria"
                  data-cy="enableExtraCriteria"
                  >mit Zusatzkriterien</mat-slide-toggle
                >
              </p>
              <p>
                <mat-slide-toggle
                  [(ngModel)]="model.enableCriteriaAbout"
                  name="enableCriteriaAbout"
                  [checked]="model.enableCriteria"
                  [disabled]="!model.enableCriteria"
                  data-cy="enableCriteriaAbout"
                  >mit Infotext</mat-slide-toggle
                >
              </p>
            </div>
          </mat-card-content>
          <mat-card-header>
            <mat-card-subtitle>PDF per E-Mail senden</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="flex-row justify-between flex-col-xs gap-16 gap-0-xs">
              @if (model) {
              <mat-form-field appearance="outline" class="flex-grow-50 sm lg">
                <mat-label>E-Mail</mat-label>
                <input
                  type="email"
                  aria-label="emailCustomer"
                  matInput
                  [(ngModel)]="model.emailCustomer"
                  name="emailCustomer"
                  data-cy="emailCustomer"
                  email="true"
                />
              </mat-form-field>
              }

              <div class="flex-grow-50 sm lg checkbox-container">
                <mat-slide-toggle
                  [(ngModel)]="model.sendToConsultant"
                  name="sendToConsultant"
                  >zusätzlich an den Berater senden</mat-slide-toggle
                >
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <button
              [disabled]="!model.emailCustomer"
              mat-flat-button
              (click)="savePdf(true)"
              data-cy="tariff-send"
            >
              @if (loadingSend == 0) {
              <mat-icon fontSet="fas" fontIcon="fa-paper-plane"></mat-icon>
              } @if (loadingSend == 1) {
              <mat-icon
                ><i
                  class="fa-solid fa-spinner fa-spin-pulse"
                  aria-hidden="true"
                ></i
              ></mat-icon>
              } @if (loadingSend == 2) {
              <mat-icon fontSet="fas" fontIcon="fa-check"></mat-icon>
              } Senden
            </button>
            <button
              mat-flat-button
              [disabled]="loadingPrint === 1 || loadingSend === 1"
              (click)="savePdf(false)"
              data-cy="tariff-print"
            >
              @if (loadingPrint == 0) {
              <mat-icon fontSet="fas" fontIcon="fa-print"></mat-icon>
              } @if (loadingPrint == 1) {
              <mat-icon
                ><i
                  class="fa-solid fa-spinner fa-spin-pulse"
                  aria-hidden="true"
                ></i
              ></mat-icon>
              } @if (loadingPrint == 2) {
              <mat-icon fontSet="fas" fontIcon="fa-check"></mat-icon>
              } Drucken
            </button>
          </mat-card-actions>
        </mat-card>
      </form>
    </div>
    <div class="flex-grow-50 md pdf-container">
      <mat-card>
        <mat-card-content>
          <div #pdf id="htmlPrint">
            <div class="pdf">
              <div class="header-container flex-row justify-between">
                <div class="logo flex-grow-50">
                  @if (isLogoLoaded) {
                  <img [src]="logo" class="header-logo" alt="logo" />
                  } @else {
                  <img
                    src="data:image/png;base64,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"
                    class="header-logo"
                    alt="logo"
                  />
                  }
                </div>
                <div class="address-container" data-cy="address">
                  <p>{{ model.firstName }} {{ model.lastName }}</p>
                  <p>{{ model.companyName }}</p>
                  <p>{{ model.street }}</p>
                  <p>{{ model.zip }} {{ model.city }}</p>
                  <p>{{ model.phone }}</p>
                  <p>{{ model.emailConsultant }}</p>
                </div>
              </div>
              @if (model.enableForeword) {
              <div data-cy="foreword-container">
                @if (model.gender === 'm' && model.name) {
                <p>Sehr geehrter Herr {{ model.name }},</p>
                } @if (model.gender === 'f' && model.name) {
                <p>Sehr geehrte Frau {{ model.name }},</p>
                } @if ( (!model.gender && model.name) || (model.name &&
                model.gender === 'd')) {
                <p>Sehr geehrte:r {{ model.name }},</p>
                } @if ( (!model.gender && !model.name) || (!model.name &&
                model.gender)) {
                <p>Sehr geehrte Damen und Herren,</p>
                }

                <p>
                  Ihre bestehende
                  {{ getProductFullName(currentProductType.id) }} wurde auf der
                  Basis der aktuellen Verbraucherschutzkriterien überprüft.
                </p>
                @if (offerTariff) {
                <p>
                  Die Verbraucherschutz-Organisationen haben für
                  Versicherungsprodukte bestimmte Leistungsmerkmale definiert.
                  Die Überprüfung dieser Kriterien ermöglicht eine objektive
                  Bewertung Ihres aktuellen Tarifs und kann einem optimierten
                  Tarif gegenübergestellt werden.
                </p>
                } @else {
                <p>
                  Die Verbraucherschutz-Organisationen haben für
                  Versicherungsprodukte bestimmte Leistungsmerkmale definiert.
                  Die Überprüfung dieser Kriterien ermöglicht eine objektive
                  Bewertung Ihres aktuellen Tarifs.
                </p>
                }
                <p>
                  Die Verbraucherschutzkriterien der
                  <strong>{{
                    getProductFullName(currentProductType.id)
                  }}</strong>
                  haben folgende Bewertung ergeben:
                </p>
              </div>
              } @if (model.note) {
              <div class="note-container">
                <p>
                  @if (model.enableForeword) {
                  <strong>Notiz: </strong>
                  }
                  {{ model.note }}
                </p>
              </div>
              }

              <mat-card class="card-select-tariff flat-card">
                <div class="flex-row justify-between gap-24">
                  <mat-card class="flat-card flex-grow-50">
                    @if (currentTariff) {
                    <mat-card-title class="company"
                      ><strong>aktueller Tarif</strong></mat-card-title
                    >
                    @if (model.enableDonut) {
                    <tariff-check-donut
                      [tariff]="currentTariff"
                      data-cy="current-donut"
                    ></tariff-check-donut>
                    } @else {
                    <div class="score-container">
                      <small>Kriterien erfüllt</small>
                      <div class="score">
                        {{ currentTariff.criterions.score_reached }} /
                        {{ currentTariff.criterions.score_possible }}
                      </div>
                    </div>
                    } @if (model.enableDonut) {
                    <div class="logo-container">
                      @if (isCurrentLogoLoaded) {
                      <img
                        [src]="currentCompanyLogoToShow"
                        class="logo"
                        alt="currentCompanyLogo"
                      />
                      } @else {
                      <i
                        class="fa-regular fa-shield-quartered fa-2x on-primary-fixed"
                        aria-hidden="true"
                      ></i>
                      }
                    </div>
                    } @if (currentTariff) {
                    <mat-card-content>
                      <p class="company" data-cy="company">
                        <strong>{{
                          currentTariff.company.name! | removeAG
                        }}</strong>
                      </p>
                      <p class="tariff-name" data-cy="current-tariff">
                        {{ currentTariff.name }},
                        {{ currentTariff.terms }}
                      </p>
                      @if (currentTariff.variant) {
                      <p class="tariff-name" data-cy="variant">
                        {{ currentTariff.variant }}
                      </p>
                      } @if (model.currentTariffPrice) {

                      <p class="tariff-name">
                        {{ model.currentTariffPrice }}€
                        {{ model.currentTariffPayment }}
                      </p>
                      } @if (currentTariff.additional_information) {
                      <p class="tariff-name" data-cy="additional_information">
                        <small class="additional-information">{{
                          currentTariff.additional_information
                        }}</small>
                      </p>
                      }
                    </mat-card-content>

                    } }
                  </mat-card>
                  @if (offerTariff) {
                  <mat-card class="flat-card flex-grow-50">
                    <mat-card-title class="company"
                      ><strong>Optimierung</strong></mat-card-title
                    >
                    @if (model.enableDonut) {
                    <tariff-check-donut
                      [tariff]="offerTariff"
                      data-cy="offer-donut"
                    ></tariff-check-donut>
                    } @else {
                    <div class="score-container">
                      <small>Kriterien erfüllt</small>
                      <div class="score">
                        {{ offerTariff.criterions.score_reached }} /
                        {{ offerTariff.criterions.score_possible }}
                      </div>
                    </div>
                    } @if (model.enableDonut) {
                    <div class="logo-container logo-offer">
                      @if (isOfferLogoLoaded) {
                      <img
                        [src]="offerCompanyLogoToShow"
                        class="logo"
                        alt="offerCompanyLogo"
                      />
                      } @else {
                      <i
                        class="fa-regular fa-shield-quartered fa-2x on-primary-fixed"
                        aria-hidden="true"
                      ></i>
                      }
                    </div>
                    }
                    <div>
                      <mat-card-content>
                        <p class="company" data-cy="company">
                          <strong>{{
                            offerTariff.company.name! | removeAG
                          }}</strong>
                        </p>
                        <p class="tariff-name" data-cy="offer-tariff">
                          {{ offerTariff.name }},
                          {{ offerTariff.terms }}
                        </p>
                        @if (offerTariff.variant) {
                        <p class="tariff-name" data-cy="variant">
                          {{ offerTariff.variant }}
                        </p>
                        } @if (model.offerTariffPrice) {
                        <p class="tariff-name">
                          {{ model.offerTariffPrice }}€
                          {{ model.offerTariffPayment }}
                        </p>
                        } @if (offerTariff.additional_information) {
                        <p class="tariff-name" data-cy="additional_information">
                          <small class="additional-information">{{
                            offerTariff.additional_information
                          }}</small>
                        </p>
                        }
                      </mat-card-content>
                    </div>
                  </mat-card>
                  }
                </div>
              </mat-card>
              @if (currentTariff || offerTariff) {
              <mat-card class="card-category flat-card">
                <mat-card-content>
                  <div class="category-list" data-cy="category-container">
                    @for (category of categories; track category.position) {
                    <div>
                      @if (category.isAdditionalCriterionCategory == false) {
                      <div class="category-container flex-row">
                        <div
                          class="category-score flex-grow-50 justify-between"
                        >
                          @if (currentTariff) {
                          <span>
                            <strong
                              >{{
                                getCategoryScore(currentTariff, category.name)
                              }}/{{ category.criterionCount }}</strong
                            ></span
                          >
                          }
                        </div>
                        <div class="category-name-crit justify-between">
                          <strong>{{ category.name }}</strong>
                        </div>
                        @if (offerTariff) {
                        <div
                          class="category-score flex-grow-50 justify-between"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;<strong
                            >{{
                              getCategoryScore(offerTariff, category.name)
                            }}/{{ category.criterionCount }}</strong
                          >
                        </div>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                </mat-card-content>
              </mat-card>
              }
            </div>
            <br />
            <br />
            <div>
              <mat-card class="card-category card-category-only flat-card">
                <mat-card-content>
                  @if (model.enableCriteria) { @for (category of categories;
                  track category.position) {
                  <div>
                    @if (category.isAdditionalCriterionCategory == false &&
                    category.criterions) {
                    <div>
                      <br />
                      <div class="category-name">
                        <strong>{{ category.name }}</strong>
                      </div>
                      @for (criteria of category.criterions; track criteria.id)
                      {
                      <div class="criterion-container">
                        @if (model.enableCriteria) {
                        <mat-card class="flat-card">
                          <div class="criterion-name">
                            {{ criteria.name }}
                            @if (criteria.value !== ' ') {
                            <span>-</span>
                            }
                            {{ criteria.value }}
                            @if (model.enableCriteriaAbout) {
                            <div class="criterion-info">
                              {{ criteria.about }}
                            </div>
                            }
                          </div>
                          @if (currentTariff || offerTariff) {
                          <mat-card-content class="flex-row">
                            @if (currentTariff) {
                            <div
                              [ngClass]="
                                isCriterionSatisfied(
                                  currentTariff,
                                  category.name,
                                  $index
                                )
                                  ? 'success'
                                  : 'fail'
                              "
                              class="criterion criterion-left flex-grow-50"
                            >
                              @if ( isCriterionSatisfied( currentTariff,
                              category.name, $index )) {
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACmSURBVHgBjY+xDcIwEEW/LykQFRuEEagDRmYENjBDABENKegZISuwAS7oMSukoswAIYeNFAmsIPk193V6/6QTiETuZQWGoliZGZoBK2JlQNh0TCuSW6lVoaYxsilNQyxwbrvXPT/ks295sVseQ9nvCcRrNyfUJte+5GWAy1D2fH6QhdTcoXKxEQKXocs/haCEf7In6UN9q202zx4ujlJKNuZknhjgDU+pTaVFejCZAAAAAElFTkSuQmCC"
                                class="check-icon"
                                alt="check-icon"
                              />
                              } @else {
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADISURBVHgBTZAxDoMwDEXtpGWhSByB3oAjQKVKjGTs2JN1rDqFsRs5AjeAI6BCFyCkmGKJP+U73/aT8XW91OCw8k7BXRVFC5t0nodj32mHLhLosAFw+fDtSvrgAHkHLqEBqJMkHA6yXIIxIFazPCphRw3u7z3fprh27oOsLaAK0yLXnlkWiWmo2c+H+Xx7m4beghnWFTsJKzUzIkMywyytEpPUzOj5QSqG/vPYQ9IKb7Lp0l9Rnc4gACFGQMOQNF4Z01JwAS7oTj8Q8HQ01X+JDAAAAABJRU5ErkJggg=="
                                class="xmark-icon"
                                alt="xmark-icon"
                              />
                              }

                              {{
                                getCriterionValue(
                                  currentTariff,
                                  category.name,
                                  $index
                                )
                              }}
                            </div>
                            } @else {
                            <div
                              class="criterion criterion-left flex-grow-50"
                            ></div>
                            } @if (offerTariff) {
                            <div
                              class="criterion criterion-right flex-grow-50"
                              [ngClass]="
                                isCriterionSatisfied(
                                  offerTariff,
                                  category.name,
                                  $index
                                )
                                  ? 'success'
                                  : 'fail'
                              "
                            >
                              @if (isCriterionSatisfied( offerTariff,
                              category.name, $index )) {
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACmSURBVHgBjY+xDcIwEEW/LykQFRuEEagDRmYENjBDABENKegZISuwAS7oMSukoswAIYeNFAmsIPk193V6/6QTiETuZQWGoliZGZoBK2JlQNh0TCuSW6lVoaYxsilNQyxwbrvXPT/ks295sVseQ9nvCcRrNyfUJte+5GWAy1D2fH6QhdTcoXKxEQKXocs/haCEf7In6UN9q202zx4ujlJKNuZknhjgDU+pTaVFejCZAAAAAElFTkSuQmCC"
                                class="check-icon"
                                alt="check-icon"
                              />
                              } @else {
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADISURBVHgBTZAxDoMwDEXtpGWhSByB3oAjQKVKjGTs2JN1rDqFsRs5AjeAI6BCFyCkmGKJP+U73/aT8XW91OCw8k7BXRVFC5t0nodj32mHLhLosAFw+fDtSvrgAHkHLqEBqJMkHA6yXIIxIFazPCphRw3u7z3fprh27oOsLaAK0yLXnlkWiWmo2c+H+Xx7m4beghnWFTsJKzUzIkMywyytEpPUzOj5QSqG/vPYQ9IKb7Lp0l9Rnc4gACFGQMOQNF4Z01JwAS7oTj8Q8HQ01X+JDAAAAABJRU5ErkJggg=="
                                class="xmark-icon"
                                alt="xmark-icon"
                              />
                              }

                              {{
                                getCriterionValue(
                                  offerTariff,
                                  category.name,
                                  $index
                                )
                              }}
                            </div>
                            }
                          </mat-card-content>
                          }
                        </mat-card>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  } }
                </mat-card-content>
              </mat-card>
              @if (model.enableCriteria && model.enableExtraCriteria) {
              <mat-card
                class="card-category flat-card"
                data-cy="extra-category-container"
              >
                <mat-card-content>
                  @for (category of categories; track category.position) {
                  <div>
                    @if (category.isAdditionalCriterionCategory == true) {
                    <div>
                      <br />
                      <div class="category-name">
                        <strong>{{ category.name }}</strong>
                      </div>
                    </div>
                    @for (criteria of category.criterions; track criteria.id) {
                    <div class="criterion-container">
                      <mat-card class="flat-card">
                        <div class="criterion-name">
                          {{ criteria.name }}
                          @if (model.enableCriteriaAbout) {
                          <div class="criterion-info">{{ criteria.about }}</div>
                          }
                        </div>
                        <div class="flex-row">
                          @if (currentTariff) {
                          <div class="criterion criterion-left flex-grow-50">
                            {{
                              getCriterionValue(
                                currentTariff,
                                category.name,
                                $index
                              )
                            }}
                          </div>
                          } @else {
                          <div
                            class="criterion criterion-left flex-grow-50"
                          ></div>
                          } @if (offerTariff) {
                          <div class="criterion criterion-right flex-grow-50">
                            {{
                              getCriterionValue(
                                offerTariff,
                                category.name,
                                $index
                              )
                            }}
                          </div>
                          } @else {
                          <div class="flex-grow-50"></div>
                          }
                        </div>
                      </mat-card>
                    </div>
                    } }
                  </div>
                  }
                </mat-card-content>
              </mat-card>
              }
            </div>
            <div id="footer" class="disclaimer">
              <p>
                <strong
                  >Haftungshinweise zu den hinterlegten Daten und Informationen
                  der Smart InsurTech AG</strong
                >
              </p>
              <p>
                Die Daten, Informationen und Bewertungen basieren auf
                sorgfältigen Recherchen, sind aber möglicherweise nicht aktuell,
                richtig oder permanent verfügbar. Die Daten und Informationen
                erheben daher keinen Anspruch auf Vollständigkeit und
                Richtigkeit der Bewertungen und der enthaltenen
                Versicherungsprodukte. Die Nutzung der angebotenen Daten und
                Informationen erfolgt auf eigenes Risiko. Ein vollständiger
                Vergleich von Versicherungsprodukten lässt sich mit Smart CHECK
                von der Smart InsurTech AG allein nicht durchführen. Die Smart
                InsurTech AG haftet nicht für das Ergebnis einer mit Hilfe ihres
                Programms durchgeführten Beratung und / oder der daraus
                resultierenden Empfehlung eines Dritten als Programmverwender.
              </p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  }
</main>
